/**
 * FloorPlanViz component.
 *
 * Phase 3 placeholder for the floor plan visualization mode.
 * In practice, Phase 3 sites have no blueprint uploaded, so ViewModeToggle
 * disables the Plan option before a user can reach this component.
 *
 * The actual floor-plan rendering (blueprint image + overlaid sensor dots +
 * zone polygons) ships in Phase 6 (admin blueprint upload tool).
 *
 * Design spec reference: section 3.3 "Floor plan mode"
 */
import { tokenValues } from '@/design/tokens';

/**
 * FloorPlanViz: placeholder component for the floor plan visualization mode.
 *
 * Shown only when a site has a blueprint uploaded (Phase 6 admin tool).
 * Phase 3 client app: the ViewModeToggle disables the Plan option,
 * so this component renders only when hasBlueprint=true (not yet possible in Phase 3).
 */
export function FloorPlanViz() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '80px 24px',
        gap: '12px',
        textAlign: 'center',
      }}
    >
      <p
        style={{
          fontFamily: tokenValues.fonts.sans,
          fontSize: '14px',
          color: tokenValues.colors.text.secondary,
          maxWidth: '320px',
          lineHeight: '1.5',
        }}
      >
        Floor plan mode requires a blueprint. Ask your admin to upload one.
      </p>
      <p
        style={{
          fontFamily: tokenValues.fonts.mono,
          fontSize: '11px',
          color: tokenValues.colors.text.tertiary,
          letterSpacing: '0.04em',
        }}
      >
        Blueprint upload available in the admin console (Phase 6)
      </p>
    </div>
  );
}
